import { useScreenOrientation } from './useScreenOrientation'
import { useEffect, useState } from 'react'
import { useFullScreenModeStore } from '@stores/useFullScreenModeStore'

export const useWhenShouldModalAdapt = () => {
  const { getOrientation } = useScreenOrientation()
  const { isFullScreenMode } = useFullScreenModeStore()
  const [whenShouldAdapt, setWhenShouldAdapt] = useState<'sm' | 'md' | null>(
    null,
  )

  useEffect(() => {
    if (!whenShouldAdapt && !isFullScreenMode) return
    getOrientation().then((orientation) => {
      setWhenShouldAdapt(orientation === 3 || orientation === 4 ? 'md' : 'sm')
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whenShouldAdapt, isFullScreenMode])

  return { whenShouldAdapt }
}
